import LayoutNode from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import { UserContext } from "vagaro-website-rendering/src/components/Definitions/UserContext";
import { SiteData } from "../Data/SiteData";
import { GetWBComponentByTypename } from "../Data/WBData";

export default function RenderNodeRecursive({ siteData, node, userContext, screenSize }: { screenSize: ScreenSize, siteData: SiteData, node: LayoutNode, userContext: UserContext }) {


    const Comp = GetWBComponentByTypename(node.typename);

    if (!Comp)
        return <></>;

    return <Comp.RenderLayout component={node} screenSize={screenSize} isEditor={true} userContext={userContext}  >
        {
            node.children.map((child, i) => {

                return <RenderNodeRecursive key={child.id} siteData={siteData} screenSize={screenSize} node={child} userContext={userContext} />
            })
        }

    </Comp.RenderLayout>


}